<template>
  <div>
    <m-category-wrapper>
      <template v-slot="{categories}">
        <div class="row p-1">
          <div class="col-lg-4 p-1 col-md-4" v-for="category in categories">
            <div class="row container py-2 border categories309">
              <h1 class="d-block h6 w-100 font-weight-bolder">{{ category.name }}</h1>
              <div class="col-6 p-1 " v-for="sub_category in category.children">
                <div class="category-item">
                  <m-a class="text-decoration-none"
                       :href="{name:'Products',query:{category: sub_category.id, category_slug: sub_category.slug}}">
                    <img class="w-100 categories309-img"
                         :src="sub_category.image"
                         :alt="sub_category.name">
                    <p class="w-100 text-dark text-center">{{ sub_category.name }}</p>
                  </m-a>
                </div>
              </div>
              <div class="w-100">
                <m-a :href="{name:'Products',query:{category: category.id, category_slug: category.slug}}"
                     class="text-dark text-decoration-none font-weight-bolder">
                  <div class="text-left">
                    <m-icon icon="icon-arrow-left" class="mr-1 d-inline-block"/>
                    <h1 class="d-inline-block h6" v-t="`category.more`"></h1>
                  </div>
                </m-a>
              </div>

            </div>
          </div>
        </div>
      </template>
    </m-category-wrapper>
  </div>
</template>

<script>
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'

export default {
  name: "Categories309",
  components: {mCategoryWrapper, mA, mIcon,}
}
</script>

<style scoped>
.categories309 {
  border-radius: 10px;
  background: white;
}

.categories309-img {
  object-fit: contain;
  aspect-ratio: 1/1;
  padding: 3px;
}

.categories309 p {
  font-size: 12px;
}

.category-item {
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  padding: 1px;
}
</style>